import * as auth from "./reducers/auth.reducers";
import * as nav from "./reducers/navigation.reducer";
import * as sidebar from "./reducers/sidebar-config-menu.reducer";

export interface MainStoreState {
  auth: auth.State;
  nav: nav.NavState;
  sidebar: sidebar.SidebarState;
}

export const reducers = {
  auth: auth.reducer,
  nav: nav.reducer,
  sidebar: sidebar.reducer,
};
